import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Checkbox,
  Stack,
  FormControlLabel,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { Header, MainColorButton } from "../../../components";
import { bottomButton } from "../../../common/styles";
import { CUSTOMER_CREATOR } from "../../../routes/path";
import { getSystemConstants } from "../../../server/axios";

/**
 * 利用者登録画面
 * @returns
 */
const CustomerPreInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isChecked, setIsChecked] = useState(false);
  const [ruleUrl, setRuleUrl] = useState("");
  const [policyUrl, setPolicyUrl] = useState("");

  useEffect(() => {
    (async () => {
      const urlRes = await getSystemConstants({ isPharmacy: true });
      urlRes.data
        .filter((item) => item.ConstCd === "pharmacy_url")
        .forEach((item) => {
          switch (Number(item.ConstBranchCd)) {
            case 1:
              setRuleUrl(item.ConstString);
              break;
            case 2:
              setPolicyUrl(item.ConstString);
              break;
            default:
              break;
          }
        });
    })();
  }, []);

  return (
    <>
      <Header title="利用者登録" />
      <Box
        height="76vh"
        marginTop="9vh"
        width="95vw"
        marginLeft="auto"
        marginRight="auto"
      >
        <Stack spacing="3%">
          <Stack spacing="1%">
            <Typography variant="h6" align="left">
              利用規約
            </Typography>
            <Box
              sx={{
                height: "25vh",
                width: "90vw",
                p: "2vw",
                border: "2px solid",
                overflowY: "scroll",
                whiteSpace: "pre-wrap",
              }}
            >
              <iframe title="rule" src={ruleUrl} height="100%" width="100%" />
            </Box>
          </Stack>
          <Stack spacing="1%">
            <Typography variant="h6" align="left">
              個人情報保護方針
            </Typography>
            <Box
              sx={{
                height: "25vh",
                width: "90vw",
                p: "2vw",
                border: "2px solid",
                overflowY: "scroll",
                whiteSpace: "pre-wrap",
              }}
            >
              <iframe
                title="policy"
                src={policyUrl}
                height="100%"
                width="100%"
              />
            </Box>
          </Stack>
          <Stack alignItems="left">
            <FormControlLabel
              control={
                <Checkbox
                  checked={isChecked}
                  value={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                />
              }
              label={
                <Typography textAlign="left" style={{ fontSize: "0.8rem" }}>
                  利用規約／個人情報保護方針に同意します<br/>
                  また、処方箋情報を薬局等へ提供することに同意します
                </Typography>
              }
            />
          </Stack>
        </Stack>
      </Box>
      <MainColorButton
        label="登録に進む"
        onClick={() => navigate(CUSTOMER_CREATOR, { state: location.state })}
        style={bottomButton}
        disabled={!isChecked}
      />
    </>
  );
};

export default CustomerPreInfo;
